<p-drawer
  [(visible)]="visible"
  position="right"
  [modal]="true"
  [closable]="true"
  [dismissible]="true"
  [style]="{ width: 'min(95vw, 680px)' }"
  styleClass="ronda-detail-dialog efetivo-drawer-dark"
  (onHide)="onHide()"
>
  <!-- Custom Header -->
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <div class="header-title">
        <i class="ri-road-map-line header-icon"></i>
        <div>
          <h2>Detalhes da Ronda</h2>
          <p class="header-subtitle">
            ID #{{ ronda?.id }} • {{ ronda?.nomePosto }}
          </p>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Content Section -->
  <div class="dialog-content" *ngIf="ronda">
    <div class="content-grid">
      <!-- Left Column: Main Details -->
      <div class="details-section">
        <!-- Status & Conclusão -->
        <div class="status-section">
          <p-tag
            [value]="ronda.concluida ? 'CONCLUÍDA' : 'EM ANDAMENTO'"
            [severity]="ronda.concluida ? 'success' : 'warn'"
            [rounded]="true"
            class="status-tag"
          >
          </p-tag>
          <div class="progress-indicator">
            <i class="fas fa-check-circle"></i>
            <span
              >{{ ronda.totalPontosChecados }} / {{ ronda.totalPontos }} pontos
              checados</span
            >
          </div>
        </div>

        <!-- Informações principais -->
        <div class="info-card">
          <div class="info-row">
            <div class="info-icon"><i class="ri-store-3-line"></i></div>
            <div class="info-content">
              <span class="info-label">Posto</span>
              <span class="info-value">{{ ronda.nomePosto }}</span>
            </div>
          </div>
          <div class="info-row">
            <div class="info-icon"><i class="ri-user-settings-line"></i></div>
            <div class="info-content">
              <span class="info-label">Efectivo</span>
              <span class="info-value">{{ ronda.nomeEfetivo }}</span>
            </div>
          </div>
          <div class="info-row">
            <div class="info-icon"><i class="ri-calendar-todo-line"></i></div>
            <div class="info-content">
              <span class="info-label">Turno</span>
              <span class="info-value">{{ ronda.nomeTurno }}</span>
            </div>
          </div>
        </div>

        <div class="divider-light"></div>

        <!-- Datas -->
        <div class="info-card">
          <div class="info-row">
            <div class="info-icon"><i class="ri-play-circle-line"></i></div>
            <div class="info-content">
              <span class="info-label">Início</span>
              <span class="info-value">{{
                ronda.dataInicio | date: "dd/MM/yyyy HH:mm:ss"
              }}</span>
            </div>
          </div>
          <div class="info-row">
            <div class="info-icon"><i class="ri-stop-circle-line"></i></div>
            <div class="info-content">
              <span class="info-label">Fim</span>
              <span class="info-value" [class.nao-concluido]="!ronda.concluida">
                {{
                  ronda.dataFim
                    ? (ronda.dataFim | date: "dd/MM/yyyy HH:mm:ss")
                    : "—"
                }}
              </span>
            </div>
          </div>
        </div>

        <!-- Observação -->
        <div class="observacao-card" *ngIf="ronda.observacao">
          <i class="ri-chat-1-line"></i>
          <div>
            <span class="info-label">Observação</span>
            <p>{{ ronda.observacao }}</p>
          </div>
        </div>

        <!-- Metadados -->
        <div class="metadata">
          <span class="meta-item">
            <i class="ri-folder-chart-line"></i>
            Escala #{{ ronda.idEscala }}
          </span>
          <span class="meta-item">
            <i class="ri-group-line"></i>
            {{ ronda.efetivosIds.length || 0 }} efectivo(s)
          </span>
        </div>
      </div>

      <!-- Right Column: Pontos Críticos -->
      <div class="checkpoints-section">
        <div class="checkpoints-header">
          <i class="ri-checkbox-multiple-line"></i>
          <h3>Pontos Críticos</h3>
          <span class="checkpoints-count"
            >{{ ronda.pontosCriticos.length || 0 }} pontos</span
          >
        </div>

        <div
          class="checkpoints-list"
          *ngIf="
            ronda.pontosCriticos && ronda.pontosCriticos.length > 0;
            else noPoints
          "
        >
          <div
            *ngFor="let ponto of ronda.pontosCriticos; trackBy: trackByPontoId"
            class="checkpoint-card"
            [class.checado]="ponto.checado"
          >
            <div class="checkpoint-status">
              <i
                *ngIf="ponto.checado"
                class="ri-checkbox-circle-fill check-icon"
              ></i>
              <i
                *ngIf="!ponto.checado"
                class="ri-checkbox-blank-circle-line pending-icon"
              ></i>
            </div>
            <div class="checkpoint-content">
              <div class="checkpoint-title">
                <span class="ordem">#{{ ponto.ordem }}</span>
                <span class="designacao">{{
                  ponto.designacao || "Ponto crítico " + ponto.idPontoCritico
                }}</span>
              </div>
              <div
                class="checkpoint-meta"
                *ngIf="ponto.checado && ponto.dataChecagem"
              >
                <i class="fas fa-clock"></i>
                <span>{{
                  ponto.dataChecagem | date: "dd/MM/yyyy HH:mm:ss"
                }}</span>
              </div>
              <div class="checkpoint-meta" *ngIf="!ponto.checado">
                <i class="ri-alert-line"></i>
                <span>Não checado</span>
              </div>
            </div>
          </div>
        </div>
        <ng-template #noPoints>
          <div class="no-points">
            <i class="ri-map-pin-off-line"></i>
            <p>Nenhum ponto crítico definido para esta ronda</p>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</p-drawer>